import styled from '@emotion/styled';

export const SensitiveDataWarning = styled.div`
	position: absolute;
	width: calc(100% - 8px);
	height: calc(100% + 50px);
	top: 0;

	display: flex;
	flex-direction: column;
	justify-content: center;
	z-index: ${({ theme }) => theme.zIndexes.modal};

	background: ${({ theme }) => theme.colors.primary1};
	border-radius: 8px;

	margin: 0 0 0 8px;
	padding: 20px;
`;

export const Title = styled.h4`
	font-size: 28px;
	line-height: 42px;
	color: #fff;

	margin-bottom: 20px;
`;

export const Text = styled.p`
	font-size: 14px;
	line-height: 21px;
	color: #fff;

	margin-bottom: 30px;
`;

const CtaButton = styled.button`
	padding: 0 15px;

	height: 40px;
	border-radius: 8px;

	display: flex;
	align-items: center;
	justify-content: center;

	font-size: 12px;
	font-weight: 500;

	@media ${({ theme }) => theme.medias.desktop} {
		padding: 0 20px;
	}

	& + button {
		margin-left: 16px;
	}

	&:hover {
		opacity: 0.8;
	}
	&:active {
		opacity: 0.5;
	}
`;

export const ButtonsWrapper = styled.div`
	display: flex;
`;

export const ContinueBtn = styled(CtaButton)`
	background: transparent;
	border: 1px solid #fff;

	color: #fff;
`;

export const CancelBtn = styled(CtaButton)`
	background: #fff;
	border: 1px solid #fff;

	color: ${({ theme }) => theme.colors.primary1};
`;
